import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { AuthenticationLayoutModule } from 'src/app/shared/layout/authentication-layout/authentication-layout.module';

const routes: Route[] = [
 {
    path: 'auth',
    loadChildren: () =>
      import('./modules/admin-auth/admin-auth.module').then(
        (m) => m.CompanyAuthModule
      ),
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AuthenticationLayoutModule 
  ],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
